<template>
  <header class="mobile-header">
    <button @click="$emit('toggle-sidebar')" class="mobile-menu-btn">
      <i class="fas fa-bars"></i>
    </button>
    <h1>НовЖивот Админ</h1>
    <div class="mobile-spacer"></div>
  </header>
</template>

<script>
export default {
  name: 'MobileHeader',
  emits: ['toggle-sidebar']
}
</script>

<style scoped>
.mobile-header {
  display: none;
  background: #1D687B;
  color: white;
  padding: 16px 20px;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 100;
}

.mobile-menu-btn {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.mobile-menu-btn:hover {
  background-color: rgba(121, 218, 242, 0.2);
}

.mobile-header h1 {
  font-size: 18px;
  margin: 0;
  font-weight: 600;
}

.mobile-spacer {
  width: 36px;
}

@media (max-width: 768px) {
  .mobile-header {
    display: flex;
  }
}
</style>
